import * as i0 from '@angular/core';
import { Directive, Input, Injectable, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { __decorate, __metadata } from 'tslib';
import * as i1 from '@angular/router';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { WINDOW } from '@domgen/dgx-fe-common';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

class QMBlockDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
    }
    ngOnInit() {
        this.renderer.setAttribute(this.hostElement.nativeElement, 'data-qm-block', 'true');
    }
}
QMBlockDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMBlockDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
QMBlockDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.12", type: QMBlockDirective, selector: "[dgxQmBlock]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMBlockDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dgxQmBlock]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class QMEncryptDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
    }
    ngOnInit() {
        this.renderer.setAttribute(this.hostElement.nativeElement, 'data-qm-encrypt', 'true');
    }
}
QMEncryptDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMEncryptDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
QMEncryptDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.12", type: QMEncryptDirective, selector: "[dgxQmEncrypt]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMEncryptDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dgxQmEncrypt]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class QMSanitiseDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
    }
    ngOnInit() {
        switch (this.dgxQmSanitise) {
            case 'block':
                this.setAttribute('data-qm-block');
                return;
            case 'encrypt':
                this.setAttribute('data-qm-encrypt');
                return;
            default:
                return;
        }
    }
    setAttribute(name) {
        this.renderer.setAttribute(this.hostElement.nativeElement, name, 'true');
    }
}
QMSanitiseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMSanitiseDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
QMSanitiseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.12", type: QMSanitiseDirective, selector: "[dgxQmSanitise]", inputs: { dgxQmSanitise: "dgxQmSanitise" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QMSanitiseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dgxQmSanitise]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { dgxQmSanitise: [{
                type: Input
            }] } });

var QuantumMetricsTransition;
(function (QuantumMetricsTransition) {
    QuantumMetricsTransition["Start"] = "QuantumMetricsTransitionStart";
    QuantumMetricsTransition["Stop"] = "QuantumMetricsTransitionStop";
})(QuantumMetricsTransition || (QuantumMetricsTransition = {}));

/** @dynamic */
let QuantumMetricsService = class QuantumMetricsService {
    constructor(window, router) {
        this.window = window;
        this.router = router;
    }
    trackNavigation() {
        if (!this.window) {
            return;
        }
        this.trackNavigationStart();
        this.trackNavigationEnd();
    }
    trackNavigationStart() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart), untilDestroyed(this))
            .subscribe(() => {
            this.window.performance.mark(QuantumMetricsTransition.Start);
        });
    }
    trackNavigationEnd() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), untilDestroyed(this))
            .subscribe(() => {
            this.window.performance.mark(QuantumMetricsTransition.Stop);
        });
    }
};
QuantumMetricsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QuantumMetricsService, deps: [{ token: WINDOW }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
QuantumMetricsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QuantumMetricsService });
QuantumMetricsService = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [Object, Router])
], QuantumMetricsService);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: QuantumMetricsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.Router }]; } });

class DgxQmModule {
    static forRoot() {
        return {
            ngModule: DgxQmModule,
            providers: [QuantumMetricsService],
        };
    }
}
DgxQmModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DgxQmModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgxQmModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DgxQmModule, declarations: [QMSanitiseDirective], imports: [CommonModule], exports: [QMSanitiseDirective] });
DgxQmModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DgxQmModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DgxQmModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [QMSanitiseDirective],
                    exports: [QMSanitiseDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DgxQmModule, QMBlockDirective, QMEncryptDirective, QMSanitiseDirective, QuantumMetricsService, QuantumMetricsTransition };
